import { render } from "./studyBlessing.vue?vue&type=template&id=b3cde6bc&scoped=true"
import script from "./studyBlessing.vue?vue&type=script&lang=js"
export * from "./studyBlessing.vue?vue&type=script&lang=js"

import "./studyBlessing.vue?vue&type=style&index=0&id=b3cde6bc&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3cde6bc"]])

export default __exports__